import React, { useContext } from 'react';
import { Tooltip } from 'components/common';
import AppContext from 'context/Context';

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed, isFluid, isRTL },
    setConfig
  } = useContext(AppContext);

  const handleClick = () => {
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('navbar-vertical-collapsed');
    setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
  };

  return (
    <Tooltip
      content="Toggle Navigation"
      placement={
        isFluid ? (isRTL ? 'bottom' : 'right') : isRTL ? 'bottom' : 'left'
      }
    >
      <div className="ptl-toggle-icon-wrapper">
        <button
          type="button"
          className="ptl-hamburger ptl-navbar-vertical-toggle"
          id="toggleNavigationTooltip"
          onClick={handleClick}
        >
          <span className="ptl-navbar-toggle-icon">
            <span className="ptl-toggle-line" />
          </span>
        </button>
      </div>
    </Tooltip>
  );
};

export default ToggleButton;
